export const FORECAST_MODE_GROUPING = "grouping";
export const FORECAST_MODE_TOTALS = "totals";
